import React from 'react';
import {SvgIcon} from "@material-ui/core";

export default function ErrorIcon(props) {
    return (
        <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
            <g fill="none" fillRule="evenodd">
                <path fill="#FF5F77" d="M8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8z" />
                <path fill="#FFF" d="M8.009 10.286c.63 0 1.143.512 1.143 1.143 0 .63-.512 1.142-1.143 1.142s-1.143-.512-1.143-1.142c0-.631.512-1.143 1.143-1.143zM8 2.712c.62 0 1.123.503 1.123 1.123v.02l-.076 4.28c-.01.56-.466 1.008-1.026 1.008S7.003 8.696 6.99 8.135l-.104-4.28c-.015-.616.472-1.128 1.088-1.143H8z" />
            </g>
        </SvgIcon>
    );

}



// WEBPACK FOOTER //
// ./src/components/controls/icons/ErrorIcon.jsx